module.exports = {
      id: "CloseWhite-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#CloseWhite-usage",
      toString: function () {
        return this.url;
      }
    }